import {
  CreateIsniValidations,
  UpdateIsniValidations,
} from 'app/components/Profile/Ids/IsniDialog/types';
import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import { idNameValidation } from 'app/components/Profile/Ids/validations';
import { isniValidation, stringValidation } from 'app/utils/validations';
import { Isni } from 'types/isni.types';

export const getDefaultValues = (isni?: Isni) => ({
  firstName: isni?.firstName || '',
  lastName: isni?.lastName || '',
  isni: isni?.isni || '',
  isDefault: isni?.default ?? false,
});

const oneOfValidation = (
  firstNameMaxLength: number,
  lastNameMaxLength: number
) => ({
  firstName: yup.string().when('lastName', {
    is: (name: string) => !name,
    ...idNameValidation(firstNameMaxLength, 'lastName'),
  }),
  lastName: yup.string().when('firstName', {
    is: (name: string) => !name,
    ...idNameValidation(lastNameMaxLength, 'firstName'),
  }),
});

const getCreateValidations = (validations: CreateIsniValidations) => {
  const { isni, firstName, lastName } = validations.properties;
  const anyOf = validations?.anyOf.map((el) => el.required).flat() || [];

  return yup.object().shape(
    {
      isni: isniValidation(isni.pattern).required(
        fieldValidationMessages.REQUIRED
      ),
      ...(anyOf.includes('firstName') && anyOf.includes('lastName')
        ? oneOfValidation(firstName.maxLength, lastName.maxLength)
        : {
            firstName: stringValidation(firstName.maxLength),
            lastName: stringValidation(lastName.maxLength),
          }),
    },
    [['firstName', 'lastName']]
  );
};

const getUpdateValidations = (validations: UpdateIsniValidations) => {
  const { firstName, lastName } = validations.properties;
  return yup
    .object()
    .shape(oneOfValidation(firstName.maxLength, lastName.maxLength), [
      ['firstName', 'lastName'],
    ]);
};

export const getIsniValidationSchema = ({
  createValidations,
  updateValidations,
  isni,
}: {
  createValidations?: CreateIsniValidations;
  updateValidations?: UpdateIsniValidations;
  isni: boolean;
}) => {
  if (isni && updateValidations) {
    return getUpdateValidations(updateValidations);
  }

  if (createValidations) {
    return getCreateValidations(createValidations);
  }

  return yup.object();
};
